var parallaxPort = document.getElementsByClassName("fill-img");
var parallax = document.getElementsByClassName("parallax-img");
var parallaxBigImage = document.getElementsByClassName("small-img");
var parallaxFillimg = document.getElementsByClassName("masked-fill");
var parallaxProduct = document.getElementsByClassName("product-parallax-img");
var parallaxCdvantage = document.getElementsByClassName("advantage-fill");
var parallaxAntiimg = document.getElementsByClassName("anti-img");
var parallaxAntizone = document.getElementsByClassName("anti_zone-img");

try{
    _simpleParallax();
}catch(err){
    setTimeout(() => {
        _simpleParallax();
    }, 1000);
}

const _simpleParallax = ()=>{
    new simpleParallax(parallaxPort, {
        overflow: true,
        delay: .7,
        scale: 1.4,
        orientation: "down",
        transition: "cubic-bezier(0,0,0,1)",
    });
    
    new simpleParallax(parallax, {
      overflow: true,
      delay: .7,
      scale: 1.4,
      orientation: "up",
      transition: "cubic-bezier(0,0,0,1)",
    });
    
    new simpleParallax(parallaxBigImage, {
        overflow: true,
        delay: .7,
        scale: 3.1,
        orientation: "up",
        transition: "cubic-bezier(0,0,0,1)",
    });
    
    new simpleParallax(parallaxFillimg, {
        overflow: true,
        delay: 0.7,
        scale: 1.5,
        orientation: "up",
        transition: "cubic-bezier(0,0,0,1)",
    });
    
    if(window.screen.width > 768) {
        new simpleParallax(parallaxProduct, {
            overflow: true,
            delay: .7,
            scale: 1.4,
            orientation: "down",
            transition: "cubic-bezier(0,0,0,1)",
        });
    }
    
    new simpleParallax(parallaxCdvantage, {
        overflow: true,
        delay: 0.7,
        scale: 1.5,
        orientation: "up",
        transition: "cubic-bezier(0,0,0,1)",
    });
    
    new simpleParallax(parallaxAntiimg, {
        overflow: true,
        delay: 0.7,
        scale: 1.5,
        orientation: "up",
        transition: "cubic-bezier(0,0,0,1)",
    });
    
    new simpleParallax(parallaxAntizone, {
        overflow: true,
        delay: 0.7,
        scale: 1.5,
        orientation: "up",
        transition: "cubic-bezier(0,0,0,1)",
    });
}